// UI
import { Heading } from "@/components/Typography"

// Translate
import { useTrans } from "@/lib/i18n"

/**
 * VoucherInstructions
 * @returns
 */
export function VoucherInstructions() {
	const t = useTrans("investor")

	return (
		<div>
			<Heading as="h2" styleAs="h5" className="mb-3">
				{t("investor:community.invites.instructions.heading")}
			</Heading>
			<p>{t("investor:community.invites.instructions.intro")}</p>
			<ol className="mt-4 ml-5 list-decimal space-y-2">
				<li>{t("investor:community.invites.instructions.step1")}</li>
				<li>{t("investor:community.invites.instructions.step2")}</li>
				<li>{t("investor:community.invites.instructions.step3")}</li>
			</ol>
		</div>
	)
}
